import { Route } from 'react-router-dom';
import { parrainagesCurrentMonthSchema } from './parrainagesCurrentMonth';
import Main from '@app/main/tables/Main';
import { parrainageSchema } from '@app/Modules/data/Parrainage/parrainage';

/**
 * Routes configurées pour le module ParrainagesCurrentMonth
 */
const ParrainagesCurrentMonthRoutes = [
    // Route de liste (principale)
    <Route
        key="parrainages-current-month"
        path="parrainagesCurrentMonth"
        element={
            <Main
                key="parrainages-current-month-main"
                pageConfig={parrainagesCurrentMonthSchema}
            />
        }
    />,

    <Route
        key="parrainages-current-month-main-data-parrainages"
        path="parrainagesCurrentMonth/data/parrainages"
        element={<Main pageConfig={parrainageSchema} />}
    />,
];

export default ParrainagesCurrentMonthRoutes;
